enum SiteSection {
  MarketSegments = 'marketingsegments',
}
export default SiteSection;
